import React, { useState } from 'react'
import icons from '../../assets/images/sprite-other-icons.svg'
import { setSuccessMessage, setDisplayPopup } from '../home/cl_LoyalltyCoins'
import { useDispatch, useSelector } from 'react-redux'

const Modal_verify = ({ title }) => {
   const dispatch = useDispatch()
   const { displayPopup } = useSelector(state => state.coinsHistory)
   return (
      <React.Fragment>
         <div className="SB-modal SB-loyaltysuccess-modal SB-modal-fullscreen" id="SB-loyaltysuccess-modal" style={{ display: displayPopup ? "block" : "none" }}>
            <div className="SB-modal-dialog">
               <div className="SB-modal-content">
                  <div className="SB-modal-close" data-dismiss="modal" onClick={() => { dispatch(setSuccessMessage(false)) ;dispatch(setDisplayPopup(false)) }}>
                     <div className="SB-iconSVG" title="close">
                        <svg xmlns="http://www.w3.org/2000/svg">
                           <use xlinkHref={`${icons}#${'icon-close'}`}></use>
                        </svg>
                     </div>
                  </div>
                  <div className="SB-modal-body">
                     <div className="SB-loyaltyLevel-success">
                        <div className="SB-iconSVG SB-iconCheck" title="close">
                           <svg xmlns="http://www.w3.org/2000/svg">
                              <use xlinkHref={`${icons}#${'icon-check'}`}></use>
                           </svg>
                        </div>
                        <div className="SB-confetti">
                           <div className="SB-confetti-Before"></div>
                        </div>
                        <div className="SB-modal-header">
                           {/* <div className="SB-modal-title">Success</div> */}
                           <p>{title}</p>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </React.Fragment>
   )
}

export default Modal_verify
